import { useQuery } from '@tanstack/react-query';
import { api } from './client';
import type { Task } from '../lib/types';

export interface TaskChainResponse {
  ancestors: Task[];
  current: Task;
  descendants: Task[];
}

export function useTaskChain(taskId: string | undefined) {
  return useQuery({
    queryKey: ['task-chain', taskId],
    queryFn: () => api<TaskChainResponse>(`/api/tasks/${taskId}/chain`),
    enabled: Boolean(taskId),
  });
}
